<template>
   <div class="leads-page">
      <div class="mt-3">
         <BDMDetails/>
      </div>
   </div>
</template>

<script>
import BDMDetails from '@/components/BDMDetails/BDMDetailsDashboard.vue';

export default {

   components: {
       BDMDetails,
   },

}
</script>